<template>
  <div>
    <div v-for="controlActor in getControlActorsForService(service.id)" :key="controlActor.id">
      <div v-if="showLabels">
        <strong>{{ controlActor.name }}</strong>
      </div>
      <component
        v-bind:is="controlActor.component"
        :vars="getActorVarsByScene(controlActor, scene)"
        class="mb-2">
      </component>
      <hr />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ControlActors',
  props: {
    service: {
      type: Object,
      required: true,
    },
    scene: {
      type: Object,
      required: true,
    },
    showLabels: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      'getControlActorsForService',
      'getActorVarsByScene',
    ]),
  },
};
</script>

<style scoped>

</style>
